export default __webpack_public_path__ + "static/studio-1-2-0f88dab9b7507d661a4b29b787bde726.jpg";